/**
 * Application Configuration
 *
 * Environment-specific configuration values loaded from Vite env variables.
 *
 * @module lib/config
 */

// =============================================================================
// API URL
// =============================================================================

/**
 * Hummingbird API base URL.
 * Used for making API calls (e.g., Geo API).
 *
 * - Development: http://localhost:8787 (local worker) or staging URL
 * - Staging: https://staging-api.hummingbirdapi.com
 * - Production: https://api.hummingbirdapi.com
 */
export const API_URL = import.meta.env.VITE_API_URL || 'https://api.hummingbirdapi.com';

// =============================================================================
// Site URLs
// =============================================================================

/**
 * Marketing site base URL.
 * Used for links to legal pages (terms, privacy, acceptable use).
 *
 * - Development: http://localhost:4321 or staging URL
 * - Staging: https://staging.hummingbirdapi.com
 * - Production: https://hummingbirdapi.com
 */
export const MARKETING_URL = import.meta.env.VITE_MARKETING_URL || 'https://hummingbirdapi.com';

// =============================================================================
// Marketing Site Links
// =============================================================================

/**
 * Helper to build marketing site URLs
 */
export function marketingUrl(path: string): string {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${MARKETING_URL}${cleanPath}`;
}

/**
 * Pre-built marketing site URLs for common pages
 */
export const links = {
  terms: marketingUrl('/terms/'),
  privacy: marketingUrl('/privacy/'),
  acceptableUse: marketingUrl('/acceptable-use/'),
  docs: marketingUrl('/docs/'),
} as const;
